<template>
  <div class="relative">
    <ui-input
      :id="id"
      ref="input"
      :model-value="modelValue"
      :type="isVisible ? 'text' : 'password'"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :disabled="disabled"
      class="pr-10"
      @update:model-value="(value) => $emit('update:modelValue', value)"
    />
    <button
      type="button"
      data-slot="password-toggle"
      :aria-label="isVisible ? tr('Hide password') : tr('Show password')"
      :aria-pressed="isVisible"
      class="absolute inset-y-0 right-0 flex w-10 cursor-pointer items-center justify-center text-muted-foreground hover:text-foreground"
      @click="() => isVisible = !isVisible"
    >
      <eye-off-icon v-if="isVisible" class="size-4" />
      <eye-icon v-else class="size-4" />
    </button>
  </div>
</template>

<script>
import { Eye, EyeOff } from '@lucide/vue';

/** Password input with a show / hide toggle. */
export default {
  name: 'PasswordField',
  components: {
    EyeIcon: Eye,
    EyeOffIcon: EyeOff,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      required: false,
      default: () => undefined,
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'current-password',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: [ 'update:modelValue' ],
  data: () => ({
    isVisible: false,
  }),
};
</script>
